import { find } from "../utils/dom"

export default function () {

  const Home = document.querySelector('#locations-content'); 
  if (!Home) return;
  console.log('Page Location');

  const swiperNyAcademy = new Swiper(".swiper-ny-academy", {
    slidesPerView: 'auto',
    centeredSlides:true,
    spaceBetween: 20,
    loop:true,
    navigation: { nextEl: ".swiper-button-ny-next", prevEl: ".swiper-button-ny-prev" },
    breakpoints: { 600:{ spaceBetween:32 } },
    on: {
      slideChange: function () {
        const activeSlide = this.slides[this.activeIndex];
        const allSlides = document.querySelectorAll('.swiper-ny-academy .swiper-slide .bg-slides-gray');
        allSlides.forEach(i=> i.classList.add('activate'));
        const bg = activeSlide?.querySelector('.bg-slides-gray');
        bg?.classList.remove('activate');
      },
    }
  });

  function updateSlideCounter(swiperInstance) {
    const current = swiperInstance.realIndex + 1;
    const total = swiperInstance.slides.length - (swiperInstance.loopedSlides * 2 || 0) || swiperInstance.slides.length;
    const el = document.getElementById("slide-counter");
    if (el) el.innerHTML = `<span class='text-white'>${current}</span><span class='text-white/40'>/${total}</span>`;
  }

  function markActiveInstructor(swiper) {
    swiper.slides.forEach(slide => slide.classList.remove('is-active'));
    const active = swiper.slides[swiper.activeIndex];
    if (active) active.classList.add('is-active');
  }

  const swiperNyInstrutores = new Swiper(".swiper-ny-instrutores", {
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides:true,
    navigation: { nextEl: ".swiper-button-instrutores-ny-next", prevEl: ".swiper-button-instrutores-ny-prev" },
    breakpoints: { 0:{ spaceBetween:12 }, 1024:{ spaceBetween:0 } },
    on:{
      init() { updateSlideCounter(this); markActiveInstructor(this); },
      slideChange() { updateSlideCounter(this); markActiveInstructor(this); }
    }
  });

  const btns = document.querySelectorAll(".button-location");          
  const panes = document.querySelectorAll("[data-body-location]");     
  const activate = (key) => {
    btns.forEach(b => {
      const active = b.dataset.btnLocation === key;
      b.classList.toggle('active', active);
      b.classList.toggle('text-white', active);
      b.classList.toggle('text-white/60', !active);
    });

    panes.forEach(p => {
      const show = p.dataset.bodyLocation === key;
      p.classList.toggle('hidden', !show);
      if (show) {
        p.querySelectorAll('.swiper').forEach(el => el.swiper?.update?.());
      }
    });
  };

  const initTabs = () => {
    
    const hash = (location.hash || '').replace('#','');
    const idsValidos = new Set(['ny','miami']);
    const initial =
      (idsValidos.has(hash) && hash) ||
      document.querySelector('.button-location.active')?.dataset.btnLocation ||
      panes[0]?.dataset.bodyLocation ||
      'ny';

    activate(initial);
  };

  btns.forEach(b => {
    b.addEventListener('click', (e) => {
      e.preventDefault();
      const key = b.dataset.btnLocation;
      activate(key);
    
      try { history.replaceState(null, '', `#${key}`); } catch {}
    });
  });

  initTabs();
}